// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"dcf8fb90","279":"4777a8d8","374":"ba8f5769","391":"8d37f3db","673":"825c4eaf","850":"ca0c391a","866":"18f4011e","887":"3084e170","963":"f440a719"}[chunkId] + ".css";
};